<template>
	<div class="login">
		<v-container class="fill-height" fluid>
			<v-row align="center" justify="center">
				<v-col cols="12" sm="8" md="4">
					<v-card class="elevation-0">
						<v-card-text>
							<template v-if="store_slug && store_slug !== ''">
								<router-link :to="'/' + store_slug + '/'" class="text-deco">
									<div class="pb-4">
										<v-img width="160" src="/assets/icons/logo-hwi.png" class="mx-auto"></v-img>
									</div>
								</router-link>
							</template>
							<template v-else>
								<router-link to="/" class="text-deco">
									<div class="pb-4">
										<v-img width="160" src="/assets/icons/logo-hwi.png" class="mx-auto"></v-img>
									</div>
								</router-link>
							</template>
							<div class="pb-3 text-center text-subtitle-1 font-weight-bold black--text">
								Form Reset Password
							</div>
							<div class="text-subtitle-2 py-5">
								<span class="black--text">Sudah punya akun?</span>
								<router-link :to="{ name: 'login-seller' }">
									<span class="font-weight-bold pl-2">Login di sini</span>
								</router-link>
							</div>
							<v-alert v-model="alerts.show" v-if="alerts.show" dense color="red lighten-1" class="white--text" dismissible> {{alerts.message}} </v-alert>
							<v-form ref="formLogin" role="form" v-on:submit.prevent="onSubmit">
								<div>
									<div class="text-subtitle-2 primary--text pb-1">Nomor Handphone</div>
									<v-text-field color="primary" @keypress="onlyNumber" @paste="validatePaste($event)" :rules="mobilephoneRules" @focus="() => fieldErrors.mobilephone=''" :error-messages="fieldErrors.mobilephone" v-model="mobilephone" validate-on-blur single-line outlined class="color-primary rounded-lg" height="40" dense></v-text-field>
								</div>
								<div>
									<div class="text-subtitle-2 primary--text pb-1">Email</div>
									<v-text-field :rules="emailRules" @focus="() => fieldErrors.email=''" :error-messages="fieldErrors.email" v-model="email" validate-on-blur single-line outlined class="color-primary rounded-lg email-field" height="40" dense hide-details="auto"></v-text-field>
								</div>
								<div class="pt-5">
									<v-btn v-if="isAttempting" x-large depressed color="primary" class="col-12 rounded-lg">
										<div class="subtitle-2">Sedang Diproses ...</div>
									</v-btn>
									<v-btn v-else x-large depressed color="primary" class="col-12 rounded-lg" type="submit">
										<div class="subtitle-2">Reset Password</div>
									</v-btn>
								</div>
							</v-form>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import {
	mapActions,
	mapState
} from 'vuex'

export default {
	components: {},
	data() {
		return {
			mobilephone: '',
			email: '',
			mobilephoneRules: [
			v => !!v || 'Nomor Handphone tidak boleh kosong'
			],
			emailRules: [
			v => !!v || 'Email tidak boleh kosong',
			],
		}
	},
	computed: {
		...mapState('authSeller', ['isAttempting', 'alerts', 'fieldErrors']),
	},
	methods: {
		...mapActions('authSeller', ['forgetPassword']),

		async validatePaste(val){
			let pasted = await val.clipboardData.getData('text')
			setTimeout(() => {
				if (!parseInt(pasted)) {
					this.mobilephone = ''
				}
			})
		},
		onSubmit() {
			if (this.$refs.formLogin.validate()) {
				this.forgetPassword({
					mobilephone: this.mobilephone,
					email: this.email
				}).then(() => {
					this.$router.push({
						name: "login-seller"
					})
				});
			}
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Lupa Password');
	}
};
</script>
